/**
 * This method will cleanup the url by removing double slashes
 *
 * http://example.com///segment1//segment2 --> http://example.com/segment1/segment2
 */
export function formatUrl(url: string): string {
  return url.replace(/([^:])\/\/+/g, '$1/');
}
